import React, { useEffect } from "react";
import "./style.css";
import image from "./image.png";
import image1 from "./image1.png";
import image2 from "./image2.png";
import shantanu from "./shantanu.jpg";
import image3 from "./image3.png";
import warehouse from "./warehouse.png";
import image4 from "./image4.png";
import omchaudhari from "./omchaudhari.jpg";
import image5 from "./image5.png";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const team = [
    {
      name: "Krishna Chaudhari",
      role: "Backend Developer",
      img: image1
    },
    {
      name: "Mohit Gupta",
      role: "Data Scientist",
      img: image
    },
    {
      name: "Darshan Deshmukh",
      role: "Software Developer",
      img: image2
    },
    {
      name: "Shantanu Kulkarni",
      role: "Technical Consultant",
      img: shantanu
    },
    {
      name: "Om Chaudhari",
      role: "Accountant",
      img: omchaudhari
    },
    {
      name: "Vijay Shekhar",
      role: "Chief Executive Officer",
      img: "https://s3.ap-south-1.amazonaws.com/assets.ynos.in/investor-profile-photos/I_300201.png"
    }
  ];

  return (
    <div className="about-page-container">
      <main className="container mx-auto px-6 py-12 md:py-24">
        <section className="about-section-hero mb-20 md:mb-32">
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">
            <div className="w-full md:w-1/2 lg:w-5/12">
              <div className="relative">
                <div className="absolute -inset-4 bg-green-200/50 rounded-2xl blur-2xl -z-10"></div>
                <img
                  src={warehouse}
                  alt="Boxes stacked in a warehouse"
                  className="about-image-floating rounded-2xl w-full h-auto object-cover"
                />
              </div>
            </div>
            <div className="w-full md:w-1/2 lg:w-7/12">
              <h2 className="about-heading text-4xl md:text-6xl font-extrabold text-green-900 mb-8">
                Who We Are
              </h2>
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                Welcome to <span className="text-green-600 font-bold">BoxDekho</span>,
                your premier online destination for high-quality packaging solutions.
                We started with a simple mission: to make acquiring durable, reliable,
                and eco-friendly boxes easy and affordable for businesses and individuals alike.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed">
                Whether you're shipping products across the globe, moving to a new home,
                or organizing your space, we have the perfect box for your needs.
                We are committed to sustainability, exceptional customer service,
                and providing products that protect what matters most to you.
              </p>
            </div>
          </div>
        </section>

        <section className="mb-20">
          <div className="mb-16 text-center">
            <h2 className="text-4xl md:text-6xl font-extrabold text-green-900 leading-tight">
              Our Leadership Team
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card flex flex-col items-center text-center">
                <div className="relative mb-6">
                  <div className="absolute inset-0 bg-green-100 rounded-full scale-110 -z-10"></div>
                  <img
                    src={member.img}
                    alt={member.name}
                    className="team-member-img"
                  />
                </div>
                <div className="mb-4">
                  <h3 className="text-2xl font-extrabold text-green-900 tracking-tight">
                    {member.name}
                  </h3>
                  <p className="text-green-600 font-bold text-sm uppercase tracking-widest mt-1">
                    {member.role}
                  </p>
                </div>
                <div className="w-12 h-0.5 bg-green-100 mb-6"></div>
                <div className="flex justify-center items-center gap-4">
                  <a href="#" className="social-icon-link" aria-label="Github">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.168 6.839 9.492.5.092.682-.217.682-.482 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.031-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.378.203 2.398.1 2.651.64.7 1.03 1.595 1.03 2.688 0 3.848-2.338 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.001 10.001 0 0022 12c0-5.523-4.477-10-10-10z" />
                    </svg>
                  </a>
                  <a href="#" className="social-icon-link" aria-label="LinkedIn">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
